import Navbar from "../../components/Navbar";
import { Helmet } from "react-helmet-async";
import Footer from "../../components/Footer";

const Impressum = () => {
  return (
    <div>
      <Helmet>
        <title>Impressum | Elektro Thome</title>
        <link rel="canonical" href="https://energy-thome.com/impressum" />
      </Helmet>
      <Navbar />
      <main style={{ padding: "1rem" }}>
        <h1>Impressum</h1>
        
        {/* Angaben gemäß § 5 TMG */}
        <p>
          <strong>Inhaber:</strong> Jörg Thome<br/>
          <strong>Adresse:</strong> Grübchenstraße 48, 66839 Schmelz, Deutschland<br/>
          <strong>Telefon:</strong> +49 6887 894429<br/>
          <strong>E-Mail:</strong> elektro_thome@yahoo.de
        </p>

        {/* Verantwortlich für den Inhalt (RStV § 55 Abs. 2) */}
        <p>
          <strong>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</strong> Jörg Thome
        </p>
        
        {/* Haftungsausschluss (optional but recommended) */}
        <h2>Haftungsausschluss</h2>
        <p>
          Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt.
          Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte
          können wir jedoch keine Gewähr übernehmen.
        </p>
        <p>
          Unsere Webseite enthält Links zu externen Webseiten Dritter,
          auf deren Inhalte wir keinen Einfluss haben.
          Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
        </p>
      </main>
      <Footer />
    </div>
  );
};

export default Impressum;
